<form #downloadForm="ngForm" *transloco="let t; read: 'download'">
  <section class="form download" [hidden]="isCreated">
    <div class="picture">
      <img src="assets/v2m-logo.svg" />
    </div>
    <div class="text">
      <h2>{{ t("title") }}</h2>
      <p>{{ t("description") }}</p>
    </div>
    <div class="salutation">
      <select
        class="form-control"
        id="salutation"
        name="salutation"
        [(ngModel)]="salutation"
        [disabled]="isCreating || isCreated"
      >
        <option value="" disabled>{{ t("salutation-empty") }}</option>
        <option value="Frau">{{ t("salutation-female") }}</option>
        <option value="Herr">{{ t("salutation-male") }}</option>
      </select>
    </div>
    <div class="lastname">
      <input
        type="text"
        class="form-control"
        [placeholder]="t('lastname')"
        id="lastname"
        name="lastname"
        [(ngModel)]="lastname"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="firstname">
      <input
        type="text"
        class="form-control"
        [placeholder]="t('firstname')"
        id="firstname"
        name="firstname"
        [(ngModel)]="firstname"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="email">
      <input
        type="email"
        class="form-control"
        [placeholder]="t('email')"
        id="email"
        name="email"
        [(ngModel)]="email"
        [disabled]="isCreating || isCreated"
        required
      />
    </div>
    <div class="phone">
      <input
        type="text"
        class="form-control"
        [placeholder]="t('phone')"
        id="phone"
        name="phone"
        [(ngModel)]="phone"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="company">
      <input
        type="text"
        class="form-control"
        [placeholder]="t('company')"
        id="company"
        name="company"
        [(ngModel)]="company"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="privacy">
      <input
        type="checkbox"
        id="privacy"
        name="privacy"
        [(ngModel)]="privacy"
        [disabled]="isCreating || isCreated"
        required
      />
      <label for="privacy">
        <a [routerLink]="['/privacy']">{{ t("privacy-text") }}</a>
      </label>
    </div>
    <div class="newsletter">
      <input
        type="checkbox"
        id="newsletter"
        name="newsletter"
        [(ngModel)]="newsletter"
        [disabled]="isCreating || isCreated"
      />
      <label for="newsletter">{{ t("newsletter-text") }}</label>
    </div>

    <div class="send">
      <button
        class="send"
        (click)="send()"
        [disabled]="!downloadForm.form.valid || isCreating || isCreated"
      >
        {{ t("send-button") }}
      </button>
    </div>

    <div class="hint">
      <p>* {{ t("mandantory") }}</p>
    </div>
  </section>

  <section class="form download" [hidden]="!isCreated">
    <div class="picture">
      <img src="assets/v2m-logo.svg" />
    </div>
    <div class="text">
      <h2>{{ t("title") }}</h2>
      <p>{{ t("send-confirmation") }}</p>
      <p>{{ t("send-spam-hint") }}</p>
    </div>
  </section>
</form>
